import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentOpsFeatureConfigResponse {
  user_manage: boolean;
  permission_manage: boolean;
  data_overview: boolean;
  content_manage: boolean;
  order_manage: boolean;
  enterprise_asset: boolean;
  operation_log: boolean;
}

export class AgentOpsFeatureConfigData {
  @Required("userManage cannot be empty")
  @IsBoolean("userManage must be a boolean")
  userManage: boolean;

  @Required("permissionManage cannot be empty")
  @IsBoolean("permissionManage must be a boolean")
  permissionManage: boolean;

  @Required("dataOverview cannot be empty")
  @IsBoolean("dataOverview must be a boolean")
  dataOverview: boolean;

  @Required("contentManage cannot be empty")
  @IsBoolean("contentManage must be a boolean")
  contentManage: boolean;

  @Required("orderManage cannot be empty")
  @IsBoolean("orderManage must be a boolean")
  orderManage: boolean;

  @Required("enterpriseAsset cannot be empty")
  @IsBoolean("enterpriseAsset must be a boolean")
  enterpriseAsset: boolean;

  @Required("operationLog cannot be empty")
  @IsBoolean("operationLog must be a boolean")
  operationLog: boolean;
}

const transformAndValidateAgentOpsFeatureConfig = (
  response: AgentOpsFeatureConfigResponse
): AgentOpsFeatureConfigData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(
      transformedData,
      AgentOpsFeatureConfigData
    );
  } catch (error) {
    console.error("Agent ops feature config data validation failed:", error.message);
    throw error;
  }
};

/** 获取智能体运营后台功能开关配置 */
export const agentOpsFeatureConfig = async ({
  agentId
}: { agentId?: string }): Promise<AgentOpsFeatureConfigData> => {
  const response = await api.get<AgentOpsFeatureConfigResponse>(
    "/agent/ops-feature-config", {},
    agentId ? {
      headers: {
        'X-Agent-Id': agentId,
      },
    } : {}
  );
  return transformAndValidateAgentOpsFeatureConfig(response.data);
};
